/* eslint-disable @typescript-eslint/naming-convention */
export enum TypescriptTypeEnum {
  STRING = 'string',
  NUMBER = 'number',
  ANY = 'any',
  BOOLEAN = 'boolean',
  NUMBER_ARRAY = 'number[]',
  BOOLEAN_ARRAY = 'boolean[]',
  ANY_ARRAY = 'any[]',
  STRING_ARRAY = 'string[]',
  ENUM = 'enum',
  NULL = 'null',
  DATE = 'date',
  DATETIME = 'datetime',
  TIMESTAMP = 'timestamp',
}
